export default "__VITE_PUBLIC_ASSET__0bfb71aa__"